/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type createJiraIssueModal_viewer$ref = any;
export type createJiraIssueModal_QueryVariables = {|
  projectId?: ?string
|};
export type createJiraIssueModal_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: createJiraIssueModal_viewer$ref,
  |}
|};
export type createJiraIssueModal_Query = {|
  variables: createJiraIssueModal_QueryVariables,
  response: createJiraIssueModal_QueryResponse,
|};
*/


/*
query createJiraIssueModal_Query(
  $projectId: ID
) {
  viewer {
    actualPersonId
    component(name: "create_jira_issue_modal")
    ...createJiraIssueModal_viewer_2CgS8h
    id
  }
}

fragment createJiraIssueModal_viewer_2CgS8h on Viewer {
  id
  project(internalId: $projectId) {
    id
    jiraSubtaskType
    jiraCloudProject {
      id
    }
    jiraCloudProjectSettings {
      id
      mapJiraEpicToPhase
    }
    jiraServerProject {
      id
    }
    jiraCloudEpicIds
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "create_jira_issue_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"create_jira_issue_modal\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createJiraIssueModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "createJiraIssueModal_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createJiraIssueModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraSubtaskType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectType",
                "kind": "LinkedField",
                "name": "jiraCloudProject",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mapJiraEpicToPhase",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerProjectType",
                "kind": "LinkedField",
                "name": "jiraServerProject",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEpicIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createJiraIssueModal_Query",
    "operationKind": "query",
    "text": "query createJiraIssueModal_Query(\n  $projectId: ID\n) {\n  viewer {\n    actualPersonId\n    component(name: \"create_jira_issue_modal\")\n    ...createJiraIssueModal_viewer_2CgS8h\n    id\n  }\n}\n\nfragment createJiraIssueModal_viewer_2CgS8h on Viewer {\n  id\n  project(internalId: $projectId) {\n    id\n    jiraSubtaskType\n    jiraCloudProject {\n      id\n    }\n    jiraCloudProjectSettings {\n      id\n      mapJiraEpicToPhase\n    }\n    jiraServerProject {\n      id\n    }\n    jiraCloudEpicIds\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c46f7fffbe2a6934afc0cf141ac48163';

module.exports = node;
